<template>
	<div>
		<div class="row">
			<div class="col-md-4">
				Message List:
				<select name="" id="" class="form-select" v-model="rule.settings.message_list_id">
					<option :value="null">- Select an option -</option>
					<option :key="list.id" v-for="list in messageLists" :value="list.id">{{list.name}}</option>
				</select>
                <br />
				
				Delivery Methods:
				<div id="deliverMethods" class="checkbox" style="margin:5px 0 10px 0; padding-top:0px;">
					<label style="margin:0;">
						<input type="checkbox" value="1" v-model="rule.settings.send_email"> Email<br/>
						<input type="checkbox" value="1" v-model="rule.settings.send_text"> Text message<br/>
						<input type="checkbox" value="1" v-model="rule.settings.send_feed"> Feed<br/>
					</label>
				</div>
				
				<input type="text" class="redemptionSubject form-control" placeholder="Subject..." v-model="rule.settings.subject"/><br/>
				<textarea class="redemptionMessage form-control" placeholder="Message..." v-model="rule.settings.message"></textarea>
			</div>
			<div class="col-md-4">
				Product:<br/>
				<select class="redemptionProductOptions form-control" v-model="rule.settings.product_id">
					<optgroup v-for="group in products" :label="group.group_name" :key="group.group_name">
						<option v-for="product in group.options" :value="product.id" :key="product.id">{{ product.name }}</option>
					</optgroup>
				</select>
			</div>
			<div class="col-md-4">
				Max Sends:
				<br />
				<select class="maxSends input-small form-control" v-model.number="rule.settings.max_sends">
			   	<option value="1000">--</option>
			   	<option v-for="maxSend in 10" :value="maxSend" :key="maxSend">{{ maxSend }}</option>
				</select><br/>
				
				Min Frequency:
				<div class="row">
					<div class="col-md-5">
						<select class="minFrequency input-small form-control" v-model="rule.settings.min_frequency">
							<option value="0">--</option>
							<option v-for="minFrequency in 365" :value="minFrequency" :key="minFrequency">{{ minFrequency }}</option>
						</select>
					</div>
					<div class="col-md-7" v-if="rule.settings.min_frequency>0">
						<select class="minFrequencyType input-small form-control" v-model="rule.settings.min_frequency_type">
							<option v-for="type in types" :value="type" :key="type">{{ type }}</option>
						</select>
					</div>
				</div><br/>
				
				Send Delay:
				<div class="row">
					<div class="col-md-5">
						<select class="delay input-small form-control" v-model="rule.settings.delay">
							<option v-for="delay in 365" :value="delay" :key="delay">{{ delay }}</option>
						</select>
					</div>
					<div class="col-md-7">
						<select class="delayType input-small form-control" v-model="rule.settings.delay_type">
							<option v-for="type in types" :value="type" :key="type">{{ type }}</option>
						</select>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			rule: {
				type: Object,
				required: true,
			},
			products: {
				type: Array,
				required: true
			},
            messageLists: {
				type: Array,
                default() {
                    return []
                }
			}
		},
		data:() => {
			return {
				types: [
					'years',
					'months',
					'days',
					'hours',
					'minutes'
				]
			}
		},
		mounted: function () {
			let vm = this;

			Vue.nextTick(() => {
				// setup defaults
				vm.rule.settings = _.extend({product_id: (vm.products && vm.products.length && vm.products[0].options && vm.products[0].options[0] ? vm.products[0].options[0].id : ''), max_sends:1, delay: 1, delay_type: 'minutes', min_frequency: 0, min_frequency_type: 'days', send_email: 1, send_text: 1, send_feed: 1}, vm.rule.settings);
				vm.$forceUpdate();
			});
		},
	}
</script>